/*@flow*/
import React, { Component } from 'react';
import Select from 'react-select';
import { Wrapper } from './style';

import type { Select as SelectType } from '../../types/Select';
import { formatMessage } from '../../CurrentLocale';

type Props = {
  className?: string,
  placeholder?: string,
  options: Array<{
    value: string,
    label: string
  }>,
  value: ?SelectType,
  onChange: SelectType => void
};

class SelectWrapped extends Component<Props> {
  render() {
    const {
      className,
      placeholder = formatMessage({ id: 'select.search_in' }),
      options,
      value,
      onChange
    } = this.props;

    return (
      <Wrapper className={className}>
        <Select
          value={value}
          onChange={onChange}
          options={options}
          className="betterSelect"
          classNamePrefix="select"
          placeholder={placeholder}
          isSearchable={false}
        />
      </Wrapper>
    );
  }
}

export default SelectWrapped;



// WEBPACK FOOTER //
// ./src/components/Select/index.js